import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 22D7F491-0873-43A4-9EE1-330F5BDC0829
 * name file-swap-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-swap-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileSwapOutlineIcon = createSvgIcon(<><path d="M17 15L14 12V14H10V12L7 15L10 18V16H14V18M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2M18 20H6V4H13V9H18Z" /></>, 'FileSwapOutlineIcon');
export default FileSwapOutlineIcon